import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";

const IconContainer = ({ icon, className, style }) => {
  if (!icon) return null;

  return <FontAwesomeIcon icon={icon} className={className} style={style} />;
};

export default IconContainer;
